import React from "react";

export default function BookmarkIcon({ color }) {
  return (
    <svg
      width="18"
      height="23"
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.04475 21.9891L8.15475 18.3234C8.5975 18.0078 9.4025 18.0078 9.8435 18.3234L14.957 21.9891C15.3683 22.2859 15.804 22.4375 16.217 22.4375C16.4376 22.4376 16.6552 22.3916 16.8523 22.3031C17.4228 22.0453 17.75 21.4719 17.75 20.7297V2.98281C17.75 1.64844 16.5723 0.5625 15.125 0.5625H2.875C1.42775 0.5625 0.25 1.64844 0.25 2.98281V20.7297C0.25 21.4719 0.57725 22.0437 1.146 22.3016C1.713 22.5578 2.406 22.4437 3.04475 21.9891ZM2.38889 2.98281C2.38889 2.5375 2.392 2.47222 2.875 2.47222H15.125C15.6063 2.47222 15.6111 2.53594 15.6111 2.98281V20.1806L10.918 16.5337C9.84525 15.7649 8.15825 15.7649 7.082 16.5337L2.38889 20.1806V2.98281Z"
        fill={color || "#B5B5B5"}
      />
    </svg>
  );
}
